import { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { NotificationManager } from 'react-notifications';
import { Segment, Grid, Button, Modal, Icon, Radio } from 'semantic-ui-react';
import { AvForm, AvField } from 'availity-reactstrap-validation';

import { map, get } from '../../../../utils/lodash';

import {
  putActivity,
  postGroupSelected,
  getSelectedGroup,
  updateGroupSelected,
  deleteGroupSelected,
  updateProjectInputs,
  updateSeriesParticipantCounts,
} from '../../../../store/actions';

import { CustomTable, CustomTooltip } from '../../../../components';
import { getPageDisable } from '../../../../utils';
import ProjectText from '../../../../components/projectText';
import { formatEvaluationPlanDisplayName } from '../../../../utils/evaluationPlan';

import '../activity.scss';

export class SelectDelete extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      loading: false,
    };
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  async handleGroupDelete() {
    const { deleteGroupSelected, groupId, currentActivity } = this.props;
    await deleteGroupSelected(groupId, currentActivity.id);
    this.toggle();
  }

  render() {
    const { modal } = this.state;
    const { triggerComp, groupParticipantLoading, t } = this.props;
    return (
      <Modal
        open={modal}
        onOpen={() => this.toggle()}
        closeIcon={
          <Icon
            onClick={() => this.toggle()}
            name="close"
            className="closeicon"
          />
        }
        size="tiny"
        trigger={triggerComp}
      >
        <Modal.Header>
          {t('activity.activity_plan.delete_confirmation')}
        </Modal.Header>
        <Modal.Content>
          <p>
            {t(
              'activity.activity_plan.are_you_sure_you_want_to_delete_this_group'
            )}
          </p>

          <div className="participant-delete-button-container">
            <Button onClick={() => this.toggle()} className="modal-cancel">
              {t('actions.cancel')}
            </Button>
            <Button
              className="modal-proceed"
              onClick={() => this.handleGroupDelete()}
              content={t('actions.delete')}
              type="submit"
              loading={groupParticipantLoading}
              disabled={groupParticipantLoading}
              negative
            />
          </div>
        </Modal.Content>
      </Modal>
    );
  }
}

class GroupParticipants extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      targetGroup: false,
      confirm: false,
      modal: false,
      nameValue: false,
      isOpen: false,
      participantsValue: false,
      reasonValue: false,
      participantCountsVaryBySeries: false,

      form: {
        name: '',
        // objectives: [],
        objectives: map(
          get(props.currentActivity, 'objective', []),
          (e) => e.id
        ),
        reason: '',
        size: '',
      },
      editMode: false,
      loadEditing: false,
    };
  }

  columns() {
    const { t, currentState, user, currentActivity } = this.props;
    const { participantCountsVaryBySeries } = this.state;

    let disabled = getPageDisable(currentActivity, user, currentState, true);
    const isGreenLitOrAbove = Number(get(currentActivity, 'statusId', 0)) >= 2;
    const removeDisabled = disabled || isGreenLitOrAbove;
    const seriesPlans = this.getSeriesPlans();

    const columns = [
      {
        width: participantCountsVaryBySeries ? 3 : 4,
        title: t('common.group_name'),
        render: (data) => {
          return (
            <div className="current-member-text">
              {data ? (data.name ? data.name : null) : null}
            </div>
          );
        },
      },
      {
        width: participantCountsVaryBySeries ? 3 : 5,
        title: t('activity.activity_plan.reason'),
        render: (data) => {
          return (
            <div className="current-member-text">
              {data ? (data.reason ? data.reason : null) : null}
            </div>
          );
        },
      },
      ...(participantCountsVaryBySeries
        ? seriesPlans.map((plan) => ({
            width: 2,
            title: this.getSeriesPlanTitle(plan),
            textAlign: 'center',
            render: (data) => (
              <div className="current-member-text">
                {this.getSeriesParticipantCount(data, plan)}
              </div>
            ),
          }))
        : [
            {
              width: 3,
              title: t('activity.activity_plan.no_of_participants'),
              textAlign: 'center',
              render: (data) => {
                return (
                  <div className="current-member-text">
                    {data ? (data.size ? data.size : null) : null}
                  </div>
                );
              },
            },
          ]),
      ...(participantCountsVaryBySeries
        ? [
            {
              width: 2,
              title: t('activity.activity_plan.total_no_of_participants'),
              textAlign: 'center',
              render: (data) => (
                <div className="current-member-text">
                  {this.getSeriesParticipantTotal(data)}
                </div>
              ),
            },
          ]
        : []),
      {
        width: 2,
        render: (data) => {
          return (
            <Segment disabled={disabled}>
              <label
                className="activity-actions-warn mb-0 first-down "
                onClick={() => this.editSelectedGroup(data)}
              >
                {t('actions.edit')}
              </label>
            </Segment>
          );
        },
      },
      {
        width: 2,
        render: (data) => {
          return (
            <Segment disabled={removeDisabled}>
              <SelectDelete
                groupId={data.id}
                triggerComp={
                  <label className="activity-actions-error first-down ">
                    {t('actions.remove')}
                  </label>
                }
                {...this.props}
              />
            </Segment>
          );
        },
      },
    ];

    return columns;
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  async onParticipantGroupChange(targetGroup) {
    const {
      t,
      putActivity,
      getSelectedGroup,
      currentActivity,
      selectedGroup = [],
    } = this.props;
    const { targetGroup: currentTargetGroup } = this.state;
    const isGreenLitOrAbove = Number(get(currentActivity, 'statusId', 0)) >= 2;
    if (isGreenLitOrAbove) {
      return;
    }

    if (
      currentTargetGroup === true &&
      targetGroup === false &&
      selectedGroup.length > 0
    ) {
      NotificationManager.error(
        t('activity.activity_plan.participant_groups.remove_all_subgroups')
      );
      return;
    }

    await putActivity('projectedOutputs', {
      participantGroup: targetGroup,
    });
    if (!targetGroup) {
      await getSelectedGroup(currentActivity.id, 'GROUP');
    }
    this.setState({
      targetGroup,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.targetGroup === true &&
      get(this.props, 'currentActivity.participantGroup', false) === true
    ) {
      this.setState({
        targetGroup: true,
      });
    }

    if (
      prevProps.currentActivity.evaluationPlans !==
      this.props.currentActivity.evaluationPlans
    ) {
      const participantCountsVaryBySeries =
        this.getSeriesParticipantCountVaries();

      if (
        participantCountsVaryBySeries !==
        this.state.participantCountsVaryBySeries
      ) {
        this.setState({ participantCountsVaryBySeries });
      }
    }
  }

  async componentDidMount() {
    const { t } = this.props;
    try {
      const { getSelectedGroup, currentActivity, t } = this.props;
      this.setState({
        targetGroup: currentActivity.participantGroup,
        participantCountsVaryBySeries: this.getSeriesParticipantCountVaries(),
      });
      getSelectedGroup(currentActivity.id, 'GROUP');
    } catch (error) {
      NotificationManager.error(t('error_messages.something_went_wrong'));
    }
  }

  participantFormReset() {
    this.setState(
      {
        loadEditing: true,
      },
      () => {
        this.form && this.form.reset();
        this.setState({ loadEditing: false });
      }
    );
  }

  editSelectedGroup(form) {
    this.toggle();
    const seriesCountValues = this.getSeriesPlans().reduce((values, plan) => {
      values[this.getSeriesCountFieldName(plan)] =
        this.getSeriesParticipantCount(form, plan);
      return values;
    }, {});

    this.setState(
      {
        form: {
          ...form,
          ...seriesCountValues,
        },
        editMode: true,
      },
      () => {
        this.participantFormReset();
      }
    );
  }

  renderSelectedGroup() {
    const { selectedGroup, t } = this.props;

    return (
      <CustomTable
        header
        columns={this.columns()}
        data={selectedGroup}
        customClass="evidence-table-grant"
        emptyMessage={t(
          'activity.activity_plan.no_sub_groups_have_been_created'
        )}
        keyExtractor={(item, index) => item.id}
      />
    );
  }

  resetGroupParticipant() {
    this.toggle();
    this.setState(
      {
        form: {
          name: '',
          objectives: [],
          reason: '',
          size: '',
        },
        editMode: false,
      },
      () => {
        this.participantFormReset();
      }
    );
  }

  async handleValidSubmit(event, values) {
    try {
      const { form, editMode } = this.state;
      const {
        t,
        postGroupSelected,
        updateGroupSelected,
        updateSeriesParticipantCounts,
        currentActivity,
      } = this.props;
      const isGreenLitOrAbove =
        Number(get(currentActivity, 'statusId', 0)) >= 2;
      const participantCount = Number(get(values, 'size', get(form, 'size')));

      if (!Number.isFinite(participantCount) || participantCount < 0) {
        NotificationManager.error(
          t(
            'activity.activity_plan.participant_groups.num_participants_must_be_at_least_zero'
          )
        );
        return;
      }

      if (editMode) {
        const seriesParticipantCounts = this.getSeriesParticipantCountPayload(
          form.id,
          values
        );

        if (
          this.state.participantCountsVaryBySeries &&
          !this.validateSeriesParticipantCounts(seriesParticipantCounts)
        ) {
          return;
        }

        const groupValues = {
          name: get(values, 'name', get(form, 'name', '')),
          reason: get(values, 'reason', get(form, 'reason', '')),
          size: get(values, 'size', get(form, 'size', '')),
        };
        const formValues = isGreenLitOrAbove
          ? {
              ...groupValues,
              name: form.name,
              reason: form.reason,
            }
          : groupValues;

        if (this.state.participantCountsVaryBySeries) {
          await updateSeriesParticipantCounts(
            currentActivity.id,
            this.getSeriesEndpointPlanId(),
            {
              seriesParticipantCountVaries: true,
              participantCounts: seriesParticipantCounts,
            }
          );
          this.resetGroupParticipant();
        } else {
          await updateGroupSelected(
            formValues,
            form.id,
            currentActivity.id,
            this
          );
        }
      } else {
        if (isGreenLitOrAbove) {
          return;
        }
        await postGroupSelected(values, currentActivity.id, this);
      }
    } catch (error) {
      // handle error here
    }
  }

  nameValue(value) {
    if (value.length > 0) {
      this.setState({
        nameValue: true,
      });
    } else {
      this.setState({
        nameValue: false,
      });
    }
  }

  participantsValue(value) {
    if (value.length > 0) {
      this.setState({
        participantsValue: true,
      });
    } else {
      this.setState({
        participantsValue: false,
      });
    }
  }

  preventNegativeParticipantValue(event) {
    if (event.key === '-' || event.key === 'Subtract') {
      event.preventDefault();
    }
  }

  handleParticipantNumberChange(event, callback) {
    const { name, value } = event.target;
    const nextValue = value !== '' && Number(value) < 0 ? 0 : value;

    event.target.value = nextValue;

    this.setState((prevState) => ({
      form: {
        ...prevState.form,
        [name]: nextValue,
      },
    }));

    if (callback) {
      callback(event.target.value);
    }
  }

  validateSeriesParticipantCounts(participantCounts) {
    const { t } = this.props;

    const hasNegativeCount = participantCounts.some(
      (count) => Number(get(count, 'participantCount', 0)) < 0
    );

    if (hasNegativeCount) {
      NotificationManager.error(
        t('activity.activity_plan.participant_groups.no_negative_numbers')
      );
      return false;
    }

    const totalParticipantCount = participantCounts.reduce(
      (total, count) => total + Number(get(count, 'participantCount', 0)),
      0
    );

    if (totalParticipantCount === 0) {
      NotificationManager.error(
        t(
          'activity.activity_plan.participant_groups.at_least_one_eval_stage_must_have_participants'
        )
      );
      return false;
    }

    return true;
  }

  reasonValue(value) {
    if (value.length > 0) {
      this.setState({
        reasonValue: true,
      });
    } else {
      this.setState({
        reasonValue: false,
      });
    }
  }

  getSeriesPlans(props = this.props) {
    const evaluationPlans = get(props.currentActivity, 'evaluationPlans', []);
    const firstSeriesPlan = evaluationPlans.find((plan) =>
      Boolean(get(plan, 'seriesParentId'))
    );
    const seriesParentId = get(firstSeriesPlan, 'seriesParentId', null);

    if (!seriesParentId) {
      return [];
    }

    return evaluationPlans
      .filter((plan) => get(plan, 'seriesParentId', null) === seriesParentId)
      .sort(
        (a, b) =>
          Number(get(a, 'seriesPosition', 0)) -
          Number(get(b, 'seriesPosition', 0))
      );
  }

  getSeriesEndpointPlanId() {
    return get(this.getSeriesPlans(), '[0].id', null);
  }

  getSeriesPlanTitle(plan) {
    const title = formatEvaluationPlanDisplayName(plan);
    const subtitle = get(plan, 'seriesSubtitle', null);
    return subtitle ? `${title} - ${subtitle}` : title;
  }

  getSeriesCountFieldName(plan) {
    return `seriesParticipantCount_${get(plan, 'id')}`;
  }

  getSeriesParticipantCount(group, plan) {
    const targetGroupId = Number(get(group, 'id', 0));
    const participantGroup = get(plan, 'participantGroups', []).find(
      (item) => Number(get(item, 'targetGroupId', 0)) === targetGroupId
    );

    return (
      get(participantGroup, 'participantCount', null) ?? get(group, 'size', 0)
    );
  }

  getSeriesParticipantTotal(group) {
    return this.getSeriesPlans().reduce(
      (total, plan) =>
        total + Number(this.getSeriesParticipantCount(group, plan)),
      0
    );
  }

  getSeriesParticipantCountPayload(targetGroupId, values) {
    return this.getSeriesPlans().map((plan) => ({
      evaluationPlanId: get(plan, 'id'),
      targetGroupId,
      participantCount: Number(
        get(values, this.getSeriesCountFieldName(plan), 0)
      ),
    }));
  }

  hasMultiStageEvaluationSeries() {
    const { currentActivity } = this.props;
    const evaluationPlans = get(currentActivity, 'evaluationPlans', []);

    return evaluationPlans.some((plan) => Boolean(get(plan, 'seriesParentId')));
  }

  getSeriesParticipantCountVaries(props = this.props) {
    const evaluationPlans = get(props.currentActivity, 'evaluationPlans', []);

    return evaluationPlans.some((plan) =>
      Boolean(get(plan, 'seriesParticipantCountVaries'))
    );
  }

  async handleSeriesParticipantCountToggle() {
    const { currentActivity, updateSeriesParticipantCounts } = this.props;
    const seriesParticipantCountVaries =
      !this.state.participantCountsVaryBySeries;

    this.setState({
      participantCountsVaryBySeries: seriesParticipantCountVaries,
    });

    await updateSeriesParticipantCounts(
      currentActivity.id,
      this.getSeriesEndpointPlanId(),
      {
        seriesParticipantCountVaries,
      }
    );
  }

  renderSeriesParticipantCountsOption() {
    const { participantCountsVaryBySeries } = this.state;
    const { t, currentActivity } = this.props;
    const isGreenLitOrAbove = Number(get(currentActivity, 'statusId', 0)) >= 2;

    if (!isGreenLitOrAbove || !this.hasMultiStageEvaluationSeries()) {
      return null;
    }

    return (
      <div className="series-participant-counts-option">
        <CustomTooltip
          state
          content={t(
            'activity.activity_plan.participant_groups.vary_by_series_tooltip'
          )}
          position="top right"
          wide="very"
        >
          <div className="group-check-wrapper">
            <label className="core-participant-title series-participant-counts-label">
              {t(
                'activity.activity_plan.participant_groups.do_your_group_numbers_vary'
              )}
            </label>
            <div className="group-toggle-switch series-participant-counts-toggle">
              <span
                className={`group-toggle-option ${
                  !participantCountsVaryBySeries
                    ? 'group-toggle-option-active'
                    : ''
                }`}
              >
                {t('actions.no')}
              </span>
              <Radio
                toggle
                checked={participantCountsVaryBySeries}
                onChange={() => this.handleSeriesParticipantCountToggle()}
              />
              <span
                className={`group-toggle-option ${
                  participantCountsVaryBySeries
                    ? 'group-toggle-option-active'
                    : ''
                }`}
              >
                {t('actions.yes')}
              </span>
            </div>
          </div>
        </CustomTooltip>
      </div>
    );
  }

  render() {
    const {
      targetGroup,
      form,
      loadEditing,
      editMode,
      nameValue,
      participantsValue,
      reasonValue,
      modal,
    } = this.state;
    const {
      groupParticipantLoading,
      currentActivity,
      helpTips,
      user,
      pageDisabled = false,
      t,
    } = this.props;

    const isGreenLitOrAbove = Number(get(currentActivity, 'statusId', 0)) >= 2;

    return (
      <Segment className="outputs-segment" disabled={pageDisabled}>
        <AvForm>
          <div className="outputs-col-custom-div">
            <Grid columns={2} stackable>
              <Grid.Row className="outputs-row">
                <>
                  <Grid.Column
                    mobile={16}
                    tablet={16}
                    computer={16}
                    className="outputs-col-custom"
                  >
                    <div className="disabled-padding">
                      <div className="group-participants-header">
                        <Segment disabled={isGreenLitOrAbove ? true : false}>
                          <div className="core-group-flex-custom">
                            <div className="group-wrapper">
                              <div className="book-logo-wrapper">
                                <div className="core-participant-res">
                                  <div className="group-check-wrapper">
                                    <CustomTooltip
                                      state={get(user, 'options.tips')}
                                      contentObject={{
                                        data: helpTips,
                                        key: '208',
                                      }}
                                      position="top left"
                                      wide="very"
                                    >
                                      <label className="core-participant-title participant-title-custom">
                                        <ProjectText
                                          defaultText={t(
                                            'activity.activity_plan.do_you_want_to_create_evaluation_subgroups_for_your_participants'
                                          )}
                                          textId={7}
                                        />
                                      </label>
                                    </CustomTooltip>

                                    <div className="group-objective-select">
                                      <div className="group-toggle-switch">
                                        <span
                                          className={`group-toggle-option ${
                                            !targetGroup
                                              ? 'group-toggle-option-active'
                                              : ''
                                          }`}
                                        >
                                          {t('actions.no')}
                                        </span>
                                        <Radio
                                          toggle
                                          checked={targetGroup}
                                          onChange={() =>
                                            this.onParticipantGroupChange(
                                              !targetGroup
                                            )
                                          }
                                          disabled={isGreenLitOrAbove}
                                        />
                                        <span
                                          className={`group-toggle-option ${
                                            targetGroup
                                              ? 'group-toggle-option-active'
                                              : ''
                                          }`}
                                        >
                                          {t('actions.yes')}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {targetGroup && !isGreenLitOrAbove ? (
                                <Button
                                  className="Secondary-Button"
                                  onClick={() => this.toggle()}
                                >
                                  <Icon name="plus" />
                                  {t(
                                    'activity.activity_plan.create_new_subgroup'
                                  )}
                                </Button>
                              ) : null}
                            </div>
                          </div>
                        </Segment>
                        {targetGroup
                          ? this.renderSeriesParticipantCountsOption()
                          : null}
                      </div>
                    </div>
                  </Grid.Column>
                </>
              </Grid.Row>
            </Grid>
            {targetGroup ? (
              loadEditing ? null : (
                <div className="participant-col">
                  {/* <Grid>
                    <Grid.Row> */}
                  <Grid.Column mobile={16} tablet={8} computer={16}>
                    <div className="">
                      <div className="add-user">
                        <Modal
                          // trigger={<label className="activity-actions-warn mb-0">Edit</label>}
                          size="small"
                          className="modal-grouping"
                          open={modal}
                          onOpen={() => this.toggle()}
                          closeIcon={
                            <Icon
                              onClick={() => this.resetGroupParticipant()}
                              name="close"
                              className="closeicon"
                            />
                          }
                        >
                          <Modal.Header>
                            {editMode
                              ? isGreenLitOrAbove
                                ? t('activity.activity_plan.update_group', {
                                    groupName: get(form, 'name', 'Group'),
                                  })
                                : t('activity.activity_plan.edit_group')
                              : t('activity.activity_plan.add_new_group')}
                          </Modal.Header>
                          <Modal.Content>
                            <div className="participant-group-div-custom"></div>
                            <AvForm
                              ref={(c) => (this.form = c)}
                              onValidSubmit={(event, values) =>
                                this.handleValidSubmit(event, values)
                              }
                              autoComplete="off"
                              model={form}
                            >
                              <div className="avfield-wrap">
                                <div className="participant-group-div-custom">
                                  <AvField
                                    label={t('common.group_name')}
                                    name="name"
                                    placeholder={t(
                                      'formulary.placeholder.enter_group_name'
                                    )}
                                    type="text"
                                    className="avfield-name"
                                    onChange={(e) =>
                                      this.nameValue(e.target.value)
                                    }
                                    validate={{
                                      required: {
                                        value: true,
                                        errorMessage: t(
                                          'formulary.validation.group_name_required'
                                        ),
                                      },
                                    }}
                                    autoComplete="off"
                                    disabled={editMode && isGreenLitOrAbove}
                                  />
                                </div>

                                {this.state.participantCountsVaryBySeries ? (
                                  <div className="participant-group-div-custom series-participant-counts-fields">
                                    <label className="series-participant-counts-modal-label">
                                      {t('formulary.number_of_participants')}
                                    </label>
                                    {this.getSeriesPlans().map((plan) => (
                                      <AvField
                                        key={get(plan, 'id')}
                                        label={this.getSeriesPlanTitle(plan)}
                                        name={this.getSeriesCountFieldName(
                                          plan
                                        )}
                                        value={get(
                                          form,
                                          this.getSeriesCountFieldName(plan),
                                          ''
                                        )}
                                        type="number"
                                        className="avfield-participants"
                                        validate={{
                                          required: {
                                            value: true,
                                            errorMessage:
                                              'Number of participants is required',
                                          },
                                          min: {
                                            value: 0,
                                            errorMessage:
                                              'Number of participants must be 0 or greater',
                                          },
                                          pattern: {
                                            value: '^[0-9]+$',
                                            errorMessage:
                                              'No negative numbers are accepted',
                                          },
                                        }}
                                        min={0}
                                        step={1}
                                        onKeyDown={(event) =>
                                          this.preventNegativeParticipantValue(
                                            event
                                          )
                                        }
                                        onChange={(event) =>
                                          this.handleParticipantNumberChange(
                                            event
                                          )
                                        }
                                        onInput={(event) =>
                                          this.handleParticipantNumberChange(
                                            event
                                          )
                                        }
                                      />
                                    ))}
                                  </div>
                                ) : (
                                  <div className="participant-group-div-custom">
                                    <AvField
                                      label={
                                        <CustomTooltip
                                          state={get(user, 'options.tips')}
                                          contentObject={{
                                            data: helpTips,
                                            key: '209',
                                          }}
                                          position="top left"
                                          wide="very"
                                        >
                                          <div>
                                            {t(
                                              'formulary.number_of_participants'
                                            )}
                                          </div>
                                        </CustomTooltip>
                                      }
                                      name="size"
                                      value={get(form, 'size', '')}
                                      type="number"
                                      className="avfield-participants"
                                      onChange={(e) =>
                                        this.handleParticipantNumberChange(
                                          e,
                                          this.participantsValue.bind(this)
                                        )
                                      }
                                      onKeyDown={(event) =>
                                        this.preventNegativeParticipantValue(
                                          event
                                        )
                                      }
                                      onInput={(event) =>
                                        this.handleParticipantNumberChange(
                                          event,
                                          this.participantsValue.bind(this)
                                        )
                                      }
                                      validate={{
                                        required: {
                                          value: true,
                                          errorMessage: t(
                                            'formulary.validation.number_of_participants_required'
                                          ),
                                        },
                                        min: {
                                          value: 0,
                                          errorMessage: t(
                                            'formulary.validation.number_of_participants_must_be_nonzero'
                                          ),
                                        },
                                        pattern: {
                                          value: '^[0-9]+$',
                                          errorMessage: t(
                                            'formulary.validation.only_numbers_accepted'
                                          ),
                                        },
                                      }}
                                      min={0}
                                      step={1}
                                    />
                                  </div>
                                )}
                              </div>

                              <div className="participant-group-div-custom">
                                <AvField
                                  label={
                                    <CustomTooltip
                                      state={get(user, 'options.tips')}
                                      contentObject={{
                                        data: helpTips,
                                        key: '212',
                                      }}
                                      position="top left"
                                      wide="very"
                                    >
                                      <div>
                                        {t(
                                          'activity.activity_plan.reason_for_this_group'
                                        )}
                                      </div>
                                    </CustomTooltip>
                                  }
                                  name="reason"
                                  type="textarea"
                                  className="avfield-reason"
                                  onChange={(e) =>
                                    this.reasonValue(e.target.value)
                                  }
                                  validate={{
                                    required: {
                                      value: true,
                                      errorMessage: t(
                                        'activity.activity_plan.group_reason_required'
                                      ),
                                    },
                                  }}
                                  autoComplete="off"
                                  disabled={editMode && isGreenLitOrAbove}
                                />
                              </div>

                              <div className="participant-buttonGroup-div">
                                {editMode ? (
                                  <div className="participant-group-discard">
                                    <div
                                      className="participant-group-discard-button"
                                      type="button"
                                      loading={groupParticipantLoading}
                                      disabled={groupParticipantLoading}
                                      onClick={() =>
                                        this.resetGroupParticipant()
                                      }
                                    >
                                      {t(
                                        'activity.activity_plan.discard_changes'
                                      )}
                                    </div>
                                  </div>
                                ) : null}

                                {editMode ? (
                                  <Button
                                    type="submit"
                                    className="modal-proceed"
                                    loading={groupParticipantLoading}
                                    disabled={groupParticipantLoading}
                                  >
                                    {t('actions.save_changes')}
                                  </Button>
                                ) : !isGreenLitOrAbove ? (
                                  <div>
                                    <Button
                                      type="submit"
                                      className="modal-proceed"
                                      loading={groupParticipantLoading}
                                      disabled={
                                        !(
                                          nameValue &&
                                          participantsValue &&
                                          reasonValue
                                        ) || groupParticipantLoading
                                      }
                                    >
                                      {t('activity.activity_plan.add_group')}
                                    </Button>
                                  </div>
                                ) : null}
                              </div>
                            </AvForm>
                          </Modal.Content>
                        </Modal>
                      </div>
                    </div>
                  </Grid.Column>
                  {/* </Grid.Row>
                  </Grid> */}
                  {this.renderSelectedGroup()}
                </div>
              )
            ) : null}
          </div>
        </AvForm>
      </Segment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    ...state.activity,
    user: state.authentication.user,
    helpTips: state.extra.activityHelpTips,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      putActivity,
      postGroupSelected,
      getSelectedGroup,
      updateGroupSelected,
      deleteGroupSelected,
      updateProjectInputs,
      updateSeriesParticipantCounts,
    },
    dispatch
  );
};

GroupParticipants = connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(GroupParticipants));

export { GroupParticipants };
